import {
  TJobValuesOverlay, TOverlayBucketSize,
} from '../interface/job-values.ts';

const overlayOptions: Record<TJobValuesOverlay, string> = {
  shewhart: 'Shewhart',
  distribution: 'Distribution',
  average: 'Average',
  median: 'Median',
  nothing: 'No overlay',
};

const overlayBucketSizeOptions: Record<TOverlayBucketSize, string> = {
  total: 'Total',
  year: 'Year',
  quarter: 'Quarter',
  month: 'Month',
  week: 'Week',
};

export default {
  rollingAverageSize: 'Rolling average size',
  showRollingAverage: 'Rolling average',
  selectOverlay: 'Overlay',
  showOverlayLabel: 'Label',
  overlayBucketSize: 'Time bucket',
  overlayOptions,
  overlayBucketSizeOptions,
};
